/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SrvProceedingListItemResponse
 */
export interface SrvProceedingListItemResponse {
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingListItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingListItemResponse
     */
    fileNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingListItemResponse
     */
    openingDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingListItemResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingListItemResponse
     */
    createdByUserCode: string;
}

/**
 * Check if a given object implements the SrvProceedingListItemResponse interface.
 */
export function instanceOfSrvProceedingListItemResponse(value: object): value is SrvProceedingListItemResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('openingDate' in value) || value['openingDate'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('createdByUserCode' in value) || value['createdByUserCode'] === undefined) return false;
    return true;
}

export function SrvProceedingListItemResponseFromJSON(json: any): SrvProceedingListItemResponse {
    return SrvProceedingListItemResponseFromJSONTyped(json, false);
}

export function SrvProceedingListItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingListItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileNumber': json['fileNumber'],
        'openingDate': (json['openingDate'] == null ? null : new Date(json['openingDate'])),
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByUserCode': json['createdByUserCode'],
    };
}

export function SrvProceedingListItemResponseToJSON(json: any): SrvProceedingListItemResponse {
    return SrvProceedingListItemResponseToJSONTyped(json, false);
}

export function SrvProceedingListItemResponseToJSONTyped(value?: SrvProceedingListItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileNumber': value['fileNumber'],
        'openingDate': value['openingDate'] == null ? value['openingDate'] : `${value['openingDate'].getFullYear()}-${String(value['openingDate'].getMonth()+1).padStart(2,'0')}-${String(value['openingDate'].getDate()).padStart(2,'0')}`,
        'createdAtUtc': value['createdAtUtc'].toISOString(),
        'createdByUserCode': value['createdByUserCode'],
    };
}

